"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tooltip = exports.SliderStyled = exports.Handle = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _polished = require("polished");

var _selectors = require("../../../shared/styles/themes/selectors");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n      transform: initial;\n      left: auto;\n      right: 11px;\n      &::after {\n        left: auto;\n        right: 0;\n        transform: initial;\n        border-left: 5px solid transparent;\n        border-right: none;\n      }\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n      transform: initial;\n      left: 11px;\n      &::after {\n        left: 0;\n        transform: initial;\n        border-right: 5px solid transparent;\n        border-left: none;\n      }\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  color: ", ";\n  margin-top: -32px;\n  white-space: nowrap;\n  position: absolute;\n  transform: translateX(-50%);\n  padding: 5px;\n  left: 50%;\n  &::after {\n    content: '';\n    position: absolute;\n    top: 100%;\n    left: 50%;\n    width: 0;\n    height: 0;\n    margin-top: -3px;\n    transform: translateX(-50%);\n    border-left: 4px solid transparent;\n    border-right: 4px solid transparent;\n    border-top: 7px solid ", ";\n  }\n  ", "\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  margin: 0 2px 25px;\n  height: 75px;\n  display: flex;\n  align-items: flex-end;\n  .rc-slider {\n    height: 38px;\n    .rc-slider-rail {\n      height: 8px;\n      background-color: ", ";\n      border-radius: initial;\n    }\n    .rc-slider-track {\n      height: 8px;\n      background-color: ", ";\n      border-radius: initial;\n    }\n    .rc-slider-step {\n      .rc-slider-dot {\n        background-color: ", ";\n        bottom: initial;\n        margin-left: -2px;\n        width: 2px;\n        height: 8px;\n        border: none;\n        border-radius: initial;\n      }\n    }\n    .rc-slider-mark {\n      .rc-slider-mark-text {\n        color: ", ";\n        margin-top: 5px;\n      }\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  height: 22px;\n  width: 22px;\n  background: ", ";\n  margin-top: -8px;\n  transform: translateX(-50%);\n  border-radius: 50%;\n  color: ", ";\n  &:active {\n    box-shadow: 0 0 5px ", ";\n  }\n  > * {\n    color: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Handle = _styledComponents["default"].span(_templateObject(), _selectors.primaryColor, _selectors.primaryColor, _selectors.formAccentColor, _selectors.secondaryColor);

exports.Handle = Handle;

var SliderStyled = _styledComponents["default"].div(_templateObject2(), function (props) {
  return (0, _polished.transparentize)(0.68, (0, _selectors.primaryColor)(props));
}, _selectors.formAccentColor, _selectors.primaryColor, _selectors.primaryColor);

exports.SliderStyled = SliderStyled;

var Tooltip = _styledComponents["default"].div(_templateObject3(), _selectors.primaryColor, _selectors.secondaryColor, _selectors.primaryColor, function (_ref) {
  var first = _ref.first;
  return first && (0, _styledComponents.css)(_templateObject4());
}, function (_ref2) {
  var last = _ref2.last;
  return last && (0, _styledComponents.css)(_templateObject5());
});

exports.Tooltip = Tooltip;